import {
  getCheckLogin,
  getMerchant,
  postJwtLogin,
  postLogout,
} from 'services/authService';
import {
  loginSuccess,
  logoutUserSuccess,
  apiError,
  reset_login_flag,
  setAuthStatus,
} from './reducer';

import { NavigateFunction } from 'react-router-dom';
import { UserLogin } from 'types/UserLogin';
import { Dispatch } from 'redux';
import { removeCookie } from 'services/helpers/cookieHelper';
import { setIsMerchantLoaded, setMerchant } from 'slices/info/reducer';

export const loginUser =
  (user: UserLogin, history: NavigateFunction) =>
  async (dispatch: Dispatch) => {
    try {
      const response: any = await postJwtLogin({
        store_name: user.storeName,
        username: user.username,
        password: user.password,
      });

      if (response) {
        const { message, error_code, data } = response;

        if (message === 'OK' && error_code === 0) {
          const merchantData = await getMerchant();

          if (merchantData) {
            const { message, error_code, data } = merchantData;
            if (message === 'OK' && error_code === 0) {
              dispatch(setMerchant(data));
              dispatch(setIsMerchantLoaded(true));
            } else {
              // console.log(data);
            }
          } else {
            console.log('No response from get Merchant');
          }
          dispatch(loginSuccess(data));
          const redirectUrl = sessionStorage.getItem('redirect') || '/';
          sessionStorage.removeItem('redirect');
          history(redirectUrl);
        } else {
          dispatch(apiError({ error: message, message, error_code }));
        }
      } else {
        console.error('No response data returned');
      }
    } catch (error) {
      dispatch(apiError({ error }));
    }
  };

export const logoutUser =
  (history: NavigateFunction) => async (dispatch: Dispatch) => {
    try {
      removeCookie('user');
      removeCookie('store_name');
      removeCookie('refreshToken');
      removeCookie('access_token');

      await postLogout();
      dispatch(logoutUserSuccess(true));
      history('/');
    } catch (error) {
      dispatch(apiError(error));
    }
  };

export const checkLogin = () => async (dispatch: Dispatch) => {
  try {
    const checkToken = await getCheckLogin();
    dispatch(setAuthStatus(checkToken));
  } catch (error) {
    dispatch(setAuthStatus(false));
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch: Dispatch) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};
